// One Tap stays off Masuren (useGoogleLoginEnabled). The GIS client is a
// separate chunk so that portal does not download it.
export default defineNuxtPlugin(() => {
  if (!useGoogleLoginEnabled()) {
    return
  }

  onNuxtReady(async () => {
    const { runGoogleOneTap } = await import('~/utils/runGoogleOneTap')
    await runGoogleOneTap()
  })
})
